import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';
import { filter, map, mergeMap } from 'rxjs/operators';
import { CanonicalSeoService } from './canonical-seo.service';
import * as AOS from 'aos';
import lightbox from 'lightbox2';
declare let $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit {
  // title = 'ghrcem-pune-angular-project';
  constructor(
    private titleService: Title,
    private meta: Meta,
    private router: Router,
    private canonical: CanonicalSeoService,
    private activatedRoute: ActivatedRoute
  ) { }

  updateDescription(desc: string, keywords: string, title: string) {
    this.titleService.setTitle(title);
    // console.log(title);
    this.meta.updateTag({ name: 'description', content: desc });
    this.meta.updateTag({ name: 'keywords', content: keywords });
  }
  ngOnInit() {
    const dynamicScripts = ['../assets/js/main.js'];
    for (let i = 0; i < dynamicScripts.length; i++) {
      const node = document.createElement('script');
      node.src = dynamicScripts[i];
      node.type = 'text/javascript';
      node.async = false;
      node.charset = 'utf-8';
      document.getElementsByTagName('head')[0].appendChild(node);
      // node.onload = function () {
      //   alert('above external js library code executed');
      // }


    }



    AOS.init();

    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map(() => this.activatedRoute),
      map((route) => {
        while (route.firstChild) route = route.firstChild;
        return route;
      }),
      filter((route) => route.outlet === 'primary'),
      mergeMap((route) => route.data)
    )
      .subscribe((event) => {
        this.updateDescription(event['description'], event['keywords'], event['title']);
      });

    this.canonical.createCanonicalLink();

  }
  ngAfterViewInit() {
    lightbox.option({
      'resizeDuration': 200,
      'wrapAround': true
    })

    // Enquiry Modal
    var modal = document.getElementById("enq-modal");
    var btn = document.getElementById("myBtn");
    var span = document.getElementsByClassName("close")[0];
    btn.onclick = function () {
      modal.style.display = "block";
    }
    // span.onclick = function() {
    //   modal.style.display = "none";
    // }

    //Chatbot script
    var s = document.createElement("script");
    s.type = "text/javascript";
    s.async = true;
    s.src = "https://chatbot.in1.nopaperforms.com/en-gb/backend/bots/niaachtbtscpt.js/4885f35478c51848/9d4303fa6f5d402cb4dcd0e0b7c88f29";
    document.body.appendChild(s);
    // Scroll To Top Button

    $(document).ready(function () {
      $(window).scroll(function () {
        if ($(this).scrollTop() > 500) {
          $('#scroll').fadeIn();
        } else {
          $('#scroll').fadeOut();
        }
      });
      $('#scroll').click(function () {
        $("html, body").animate({ scrollTop: 0 }, 600);
        return false;
      });
    });




  }
}
